export default () => ({
    clubs: []
})